export enum ENCODING {
  WINDOWS_1251 = "windows-1251",
  UTF_16LE = "UTF-16LE",
  UTF_16 = "UTF-16",
  UTF_8 = "UTF-8",
}
